// extracted by mini-css-extract-plugin
module.exports = {"firstEnter":"firstEnter___1VlfO","checkbox":"checkbox___1zsuW","checkmark":"checkmark___1vjgj","agree":"agree___27ww2","ja":"ja___1dbEx","link":"link___1AHRs","zh":"zh___TPfxh"};